<template>
  <div class="pa-message-additional-box">
    <div class="pa-thumbnail-preview" :class="additionalClass" v-if="url !== null">
      <img :src="url" />
    </div>
  </div>
</template>

<script>
import { GetMe } from '@/graphql/queries/User.graphql'

import {GetModalAlertInfomations} from '@/graphql/queries/Character.graphql'

export default {
  props : {
    isDisabeld  : {
      default: false
    }
  },

  data(){
    return {
      url             : null,
      additionalClass : {
        'is-disabled' : false
      },
    };
  },

  apollo : {
    me: GetMe,

    modalAlertInfomations : {
      query: GetModalAlertInfomations
    }
  },

  computed : {
    isPictureThumbnail(){
      if(typeof this.me === 'undefined') return false;

      if(
        (this.me.primaryCharacter.thumbnail_type === 'picture') &&
        (this.me.primaryCharacter.thumbnail !== null)
      ){
        return true;
      }else{
        return false;
      }
    }
  },

  watch : {
    isDisabeld: {
      handler(value){
        if(value === true){
          this.additionalClass['is-disabled'] = true;
        }else{
          this.additionalClass['is-disabled'] = false;
        }
      }
    },
    
    me : {
      handler(data){
        if(typeof data === 'undefined') return;
        
        if( this.isPictureThumbnail ){
          this.url = data.primaryCharacter.thumbnail.url;

          this.$apollo.queries.modalAlertInfomations.refetch();
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
@import "@/components/Pages/Office/MessageApp/MessageAppForm.scss";

.pa-message-additional-box{
  .pa-thumbnail-preview{
    width:280px;
    height:280px;
    margin:1rem auto 0;
    position:relative;
    overflow:hidden;
    text-align: center;

    img{
      border:2px solid #759593;
      border-radius: 50%;
    }
  }
}

.pa-message-set{
  &-default{
    .pa-message-additional-box{
      .pa-thumbnail-preview{
        img{
          border-color: #759593;
        }
      }
    }
  }

  &-lilica{
    .pa-message-additional-box{
      .pa-thumbnail-preview{
        img{
          border-color: #c496c7;
        }
      }
    }
  }
}
</style>